import { shallow } from "zustand/shallow";

export function computed<const TDeps extends readonly unknown[] = unknown[], TResult = unknown>(
	depsFn: () => TDeps,
	computeFn: (...deps: TDeps) => TResult
): () => TResult {
	let prevDeps: TDeps;
	let cachedResult: TResult;
	return () => {
		const deps = depsFn();
		if (prevDeps === undefined || !shallow(prevDeps, deps)) {
			prevDeps = deps;
			cachedResult = computeFn(...deps);
		}
		return cachedResult;
	};
}
